/**
 * Плашка у курсора, пока карточку каталога тащат на чертёж или в 3D: название того,
 * что тащат. Над холстом за курсором и так едет призрак, а над панелями без плашки
 * непонятно, идёт ли перетаскивание. Мышь сквозь плашку проходит — она ничего не ловит.
 * Рисуется порталом в body: у панелей каталога размытый фон (`backdrop-filter`), а внутри
 * такого блока `position: fixed` считается от панели, а не от окна.
 */
import { createPortal } from "react-dom";
import { UIKit } from "@/shared/ui";
import type { CatalogDragState } from "../hooks/useCatalogCardDrag";

export const CatalogDragChip = ({ chip }: { chip: CatalogDragState | null }) =>
	chip &&
	createPortal(
		<div
			className="pointer-events-none fixed z-50 max-w-50 truncate rounded-md border border-accent/40 bg-white/95 px-2 py-1 text-xs font-medium text-accent shadow-lg"
			style={{ left: chip.x + 14, top: chip.y + 14 }}
		>
			<UIKit.Text as="span">{chip.title}</UIKit.Text>
		</div>,
		document.body,
	);
